(function () {
  function swapWithFade(img, big, set) {
    if (!big) return;
    img.style.opacity = '0';
    const done = () => { img.style.opacity = '1'; img.removeEventListener('load', done); };
    img.addEventListener('load', done, { once: true });
    if (set) img.srcset = set; else img.removeAttribute('srcset');
    img.src = big;
  }

  document.addEventListener('click', function(e){
    const btn = e.target.closest('.card__thumb'); if(!btn) return;
    const card = btn.closest('.hd-art-card'); if(!card) return;
    const mainImg = card.querySelector('.hd-art-img'); if(!mainImg) return;

    swapWithFade(mainImg, btn.getAttribute('data-main'), btn.getAttribute('data-srcset'));

    card.querySelectorAll('.card__thumb.is-active').forEach(el => el.classList.remove('is-active'));
    btn.classList.add('is-active');
  }, true);

  /* OPTIONAL: hover preview with same fade (keep if you added earlier) */
  document.addEventListener('mouseover', function(e){
    const btn = e.target.closest('.card__thumb'); if(!btn) return;
    const card = btn.closest('.hd-art-card'); if(!card) return;
    const img = card.querySelector('.hd-art-img'); if(!img) return;
    if(!img.dataset.origSrc){ img.dataset.origSrc = img.src; img.dataset.origSet = img.srcset || ''; }
    swapWithFade(img, btn.getAttribute('data-main'), btn.getAttribute('data-srcset'));
  }, true);

  document.addEventListener('mouseout', function(e){
    const btn = e.target.closest('.card__thumb'); if(!btn) return;
    const card = btn.closest('.hd-art-card'); if(!card) return;
    const img = card.querySelector('.hd-art-img'); if(!img) return;

    const active = card.querySelector('.card__thumb.is-active');
    const toSrc  = active ? active.getAttribute('data-main')   : (img.dataset.origSrc || img.src);
    const toSet  = active ? active.getAttribute('data-srcset') : (img.dataset.origSet || '');
    swapWithFade(img, toSrc, toSet);
  }, true);
})();
